// extracted by mini-css-extract-plugin
export var aircallIframe = "_e8-3";
export var fabContainer = "_e8-5";
export var fabRinging = "_e8-6";
export var loadingOverlay = "_e8-4";
export var pulse = "_e8-7";
export var widgetContent = "_e8-2";
export var widgetPanel = "_e8-0";
export var widgetPanelExpanded = "_e8-1";